import gql from 'graphql-tag';
import { checklistStepFragment } from './fragments';

export const UPDATE_CHECKLIST_PHOTO_ID = gql`
  mutation UpdateChecklistStep($payload: UpdateChecklistPhotoIdStepInput!) {
    updateChecklistPhotoIDStep(payload: $payload) {
      success
      message
      data {
        finNumber
        checkList {
          ${checklistStepFragment}
        }
      }
    }
  }
`;

export const UPDATE_CHECKLIST_INSURANCE_ID = gql`
  mutation UpdateChecklistStep($payload: UpdateChecklistInsuranceStepInput!) {
    updateChecklistInsuranceStep(payload: $payload) {
      success
      message
      data {
        finNumber
        checkList {
          ${checklistStepFragment}
        }
      }
    }
  }
`;

export const UPDATE_CHECKLIST_PATIENT_INFO = gql`
  mutation UpdateChecklistStep($payload: UpdateChecklistPatientInfoStepInput!) {
    updateChecklistPatientInfoStep(payload: $payload) {
      success
      message
      data {
        finNumber
        checkList {
          ${checklistStepFragment}
        }
      }
    }
  }
  `;

export const UPDATE_CHECKLIST_FORM = gql`
mutation UpdateChecklistStep($payload: UpdateChecklistConsentFormStepInput!) {
  updateChecklistConsentFormStep(payload: $payload) {
      success
      message
      data {
        finNumber
        checkList {
          ${checklistStepFragment}
        }
      }
    }
  }
`;

export const PRE_REG_CHECK_IN = gql`
  mutation preRegCheckIn(
    $lastName: String!
    $dateOfBirth: String!
    $zipCode: String!
    $eventId: String!
  ) {
    createPreRegToken(
      lastName: $lastName
      zipCode: $zipCode
      dateOfBirth: $dateOfBirth
      eventId: $eventId
    ) {
      success
      preRegToken {
        jwt_token
        token_type
        expires_in
      }
      error
    }
  }
`;

export const UPDATE_CHECKLIST_GUARANTOR = gql`
  mutation UpdateChecklistStep($payload: UpdateChecklistGuarantorInfoStepInput!) {
    updateChecklistGuarantorInfoStep(payload: $payload) {
      success
      message
      data {
        finNumber
        checkList {
          ${checklistStepFragment}
        }
      }
    }
  }
`;

export const SUBMIT_QUESTION = gql`
  mutation ServiceTicket($encryptedIncident: String!) {
    createIncident(encryptedIncident: $encryptedIncident) {
      incidentId
    }
  }
`;

export const UPDATE_PROCESS_STATUS = gql`
  mutation updateProcessStatus($updateProcessStatusInput: UpdateProcessStatusInput!) {
    updateProcessStatus(updateProcessStatusInput: $updateProcessStatusInput) {
      success
      message
      data {
        eventId
        complete
      }
    }
  }
`;

export const UPDATE_PREREG_STATUS = gql`
  mutation updatePreregStatus($updatePreregStatusInput: UpdatePreregStatusInput!) {
    updatePreregStatus(updatePreregStatusInput: $updatePreregStatusInput) {
      success
      message
    }
  }
`;

export const UPDATE_COLLECTION_ATTEMPTS = gql`
  mutation updateCollectionAttempts(
    $updateCollectionAttemptsInput: UpdateCollectionAttemptsInput!
  ) {
    updateCollectionAttempts(updateCollectionAttemptsInput: $updateCollectionAttemptsInput) {
      success
      message
    }
  }
`;
